// Remove jQuery dependency and use vanilla JavaScript
document.addEventListener('DOMContentLoaded', function() {
    // Single function to handle sidebar toggle
    function toggleSidebar() {
        const body = document.body;
        const isMobile = window.innerWidth <= 767;
        
        if (isMobile) {
            body.classList.toggle('sidebar-open');
        } else {
            body.classList.toggle('sidebar-collapse');
        }
    }

    // Add click event listeners to both bars and times icons
    const barsIcon = document.querySelector(".fas.fa-bars");
    if (barsIcon) {
        barsIcon.addEventListener('click', toggleSidebar);
    }

    const timesIcon = document.querySelector(".fas.fa-times");
    if (timesIcon) {
        timesIcon.addEventListener('click', toggleSidebar);
    }

    // Handle window resize
    window.addEventListener('resize', function() {
        const body = document.body;
        if (window.innerWidth > 767) {
            body.classList.remove('sidebar-open');
        } else {
            body.classList.remove('sidebar-collapse');
        }
    });

    // Close sidebar when clicking outside on mobile
    document.addEventListener('click', function(event) {
        const sidebar = document.querySelector('.main-sidebar');
        const toggleButton = document.querySelector('.sidebar-toggle');
        
        if (window.innerWidth <= 767 && 
            sidebar && 
            !sidebar.contains(event.target) && 
            !toggleButton?.contains(event.target)) {
            document.body.classList.remove('sidebar-open');
        }
    });
});

// You can remove this function if not needed elsewhere
export function initSidebarToggle() {
    const toggleBtn = document.querySelector(".sidebar-toggle");
    if (toggleBtn) {
        toggleBtn.addEventListener("click", function() {
            const body = document.body;
            const isMobile = window.innerWidth <= 767;
            
            if (isMobile) {
                body.classList.toggle('sidebar-open');
            } else {
                body.classList.toggle('sidebar-collapse');
            }
        });
    }
}
